import React, { useState, useEffect } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';

interface SearchBarProps {
  onSearch: (searchTerm: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = "Rechercher un streamer, titre, jeu...",
  debounceMs = 300
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      onSearch(searchTerm);
    }, debounceMs);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, onSearch, debounceMs]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleClear = () => {
    setSearchTerm('');
  };

  return (
    <div className="search-section">
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleInputChange}
        />
        <div className="search-icon">
          <FaSearch />
        </div>
        {searchTerm && (
          <button
            className="search-clear-btn"
            onClick={handleClear}
            type="button"
            aria-label="Effacer la recherche"
          >
            <FaTimes />
          </button>
        )}
      </div>
      {searchTerm && (
        <div className="search-info">
          Recherche pour : <em>"{searchTerm}"</em>
        </div>
      )}
    </div>
  );
};

export default SearchBar;